module.exports = __webpack_public_path__ + "img/BRCA3_Neutrophils.cc0c1b4c.png";